/* ═══════════════════════════════════════════════
   SILENT VALOR — INTERACTIONS
   ═══════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Announcement Bar Rotation ── */
  function initAnnounce() {
    var slides = document.querySelectorAll('.sv-announce__slide');
    if (slides.length < 2) return;
    var bar = document.querySelector('.sv-announce');
    var paused = false;
    if (bar) {
      bar.addEventListener('mouseenter', function(){ paused = true; });
      bar.addEventListener('mouseleave', function(){ paused = false; });
    }
    var idx = 0;
    setInterval(function () {
      if (paused) return;
      slides[idx].classList.remove('is-active');
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add('is-active');
    }, 4000);
  }

  /* ── Header Scroll (solid on scroll) ── */
  function initHeaderScroll() {
    var header = document.querySelector('.sv-header');
    if (!header) return;
    var isHome = document.body.classList.contains('sv-page-home');
    if (!isHome) return; /* Non-home pages are always solid via CSS */

    function check() {
      if (window.scrollY > 40) {
        header.classList.add('is-solid');
      } else {
        header.classList.remove('is-solid');
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* ── Mobile Menu ── */
  function initMobileMenu() {
    var btn = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('.sv-mobile-menu');
    if (!btn || !menu) return;

    btn.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      btn.classList.toggle('is-active', open);
      document.documentElement.classList.toggle('sv-menu-open', open);
    });

    /* Close on link click */
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menu.classList.remove('is-open');
        btn.classList.remove('is-active');
        document.documentElement.classList.remove('sv-menu-open');
      });
    });
  }

  /* ── Mega Menu (desktop) ── */
  function initMegaMenu() {
    var trigger = document.querySelector('.sv-nav__mega-trigger');
    if (!trigger) return;
    var timeout;
    trigger.addEventListener('mouseenter', function () {
      clearTimeout(timeout);
      trigger.classList.add('is-open');
    });
    trigger.addEventListener('mouseleave', function () {
      timeout = setTimeout(function () {
        trigger.classList.remove('is-open');
      }, 150);
    });
  }

  /* ── Active Nav Link ── */
  function initActiveNav() {
    var path = window.location.pathname.replace(/\/index\.html$/, '/').replace(/\.html$/, '');
    document.querySelectorAll('.sv-nav__link').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      var linkPath = href.replace(/\/index\.html$/, '/').replace(/\.html$/, '');
      if (path.indexOf(linkPath) === 0 && linkPath !== '/' && linkPath !== '.') {
        link.classList.add('is-active');
      }
    });
  }

  /* ── Scroll Reveals ── */
  function initReveals() {
    var els = document.querySelectorAll('.sv-reveal');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ── 3D Tilt on Tiles ── */
  function initTilt() {
    document.querySelectorAll('.sv-tile').forEach(function (tile) {
      var inner = tile.querySelector('.sv-tile__inner');
      if (!inner) return;
      tile.addEventListener('mousemove', function (e) {
        var r = tile.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        inner.style.transform = 'rotateY(' + (x * 6) + 'deg) rotateX(' + (-y * 6) + 'deg)';
      });
      tile.addEventListener('mouseleave', function () {
        inner.style.transform = 'rotateY(0) rotateX(0)';
      });
    });
  }

  /* ── Spotlight Border on Product Cards ── */
  function initSpotlight() {
    document.querySelectorAll('.sv-product-card').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mouse-x', (e.clientX - r.left) + 'px');
        card.style.setProperty('--mouse-y', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ── GSAP Scroll Animations ── */
  function initGSAP() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    if (document.querySelector('.sv-hero__media')) {
      gsap.to('.sv-hero__media-inner', {
        yPercent: 10,
        ease: 'none',
        scrollTrigger: { trigger: '.sv-hero', start: 'top top', end: 'bottom top', scrub: true }
      });
    }

    if (document.querySelector('.sv-story__image')) {
      gsap.fromTo('.sv-story__image', { y: 30 }, {
        y: -30, ease: 'none',
        scrollTrigger: { trigger: '.sv-story', start: 'top bottom', end: 'bottom top', scrub: true }
      });
    }
  }

  /* ── Init ── */
  function init() {
    initAnnounce();
    initHeaderScroll();
    initMobileMenu();
    initMegaMenu();
    initActiveNav();
    initReveals();
    initTilt();
    initSpotlight();

    /* GSAP — wait for CDN load */
    if (typeof gsap !== 'undefined') {
      initGSAP();
    } else {
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
          clearInterval(poll);
          initGSAP();
        }
        if (tries > 25) clearInterval(poll);
      }, 200);
    }
  }

  /* ── Cookie Consent Banner ── */
  function initCookieConsent() {
    if (localStorage.getItem('sv-cookie-consent')) return;

    /* Build the privacy policy link relative to current page depth */
    var path = window.location.pathname;
    var depth = (path.match(/\//g) || []).length - 1;
    var prefix = '';
    /* For file:// or paths like /dir/page.html, figure out relative prefix */
    if (path.indexOf('/policies/') !== -1) {
      prefix = '../policies/';
    } else if (path.indexOf('/systems/') !== -1 ||
               path.indexOf('/intel/') !== -1 ||
               path.indexOf('/mission/') !== -1 ||
               path.indexOf('/community/') !== -1 ||
               path.indexOf('/support/') !== -1 ||
               path.indexOf('/products/') !== -1) {
      prefix = '../policies/';
    } else {
      prefix = 'policies/';
    }

    var banner = document.createElement('div');
    banner.className = 'sv-cookie-banner';
    banner.innerHTML =
      '<div class="sv-cookie-banner__text">' +
        'We use cookies to improve your experience and analyze site traffic. ' +
        '<a href="' + prefix + 'privacy.html">Privacy Policy</a>' +
      '</div>' +
      '<div class="sv-cookie-banner__actions">' +
        '<button class="sv-btn sv-btn--primary sv-btn--small" data-cookie-accept>Accept</button>' +
        '<button class="sv-btn sv-btn--ghost sv-btn--small" data-cookie-decline>Decline</button>' +
      '</div>';

    document.body.appendChild(banner);

    function dismiss(value) {
      localStorage.setItem('sv-cookie-consent', value);
      banner.classList.add('is-hidden');
      setTimeout(function () {
        if (banner.parentNode) banner.parentNode.removeChild(banner);
      }, 500);
    }

    banner.querySelector('[data-cookie-accept]').addEventListener('click', function () {
      dismiss('accepted');
    });
    banner.querySelector('[data-cookie-decline]').addEventListener('click', function () {
      dismiss('declined');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── PDP Gallery thumbnail switcher (images + video) ── */
  var galleryMain = document.getElementById('galleryMain');
  var galleryMainWrap = galleryMain ? galleryMain.parentElement : null;
  if (galleryMain) {
    document.querySelectorAll('.sv-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = this.dataset.src;
        var videoSrc = this.dataset.video;

        // Remove active from all thumbs
        document.querySelectorAll('.sv-gallery__thumb').forEach(function (t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');

        // Remove any existing video in the main area
        var existingVideo = galleryMainWrap.querySelector('video');
        if (existingVideo) {
          existingVideo.pause();
          existingVideo.remove();
        }

        if (videoSrc) {
          // Show video
          galleryMain.style.display = 'none';
          var video = document.createElement('video');
          video.src = videoSrc;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          galleryMainWrap.appendChild(video);
        } else if (src) {
          // Show image
          galleryMain.style.display = '';
          galleryMain.src = src;
        }
      });
    });
  }

  

  /* ── Hotspot Explorer: Tab switching ── */
  // Initialize: hide non-active panels
  document.querySelectorAll('.sv-explorer__panel').forEach(function(p) {
    if (!p.classList.contains('is-active')) {
      p.style.display = 'none';
    }
  });

  document.querySelectorAll('.sv-explorer__tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      var target = this.dataset.panel;
      if (!target) return;
      // Remove active from all tabs
      document.querySelectorAll('.sv-explorer__tab').forEach(function(t) {
        t.classList.remove('is-active');
      });
      this.classList.add('is-active');
      // Hide all panels, show target
      document.querySelectorAll('.sv-explorer__panel').forEach(function(p) {
        p.classList.remove('is-active');
        p.style.display = 'none';
      });
      // Find panel by data-panel attribute
      var panel = document.querySelector('.sv-explorer__panel[data-panel="' + target + '"]');
      if (panel) {
        panel.classList.add('is-active');
        panel.style.display = 'block';
      }
      // Update dynamic feature bullets
      updateFeatureBullets(target);
    });
  });

  /* ── Dynamic feature bullets from hotspot data ── */
  function updateFeatureBullets(panelId) {
    var panel = document.querySelector('.sv-explorer__panel[data-panel="' + panelId + '"]');
    var bulletsList = document.querySelector('.sv-explorer__features-list');
    if (!panel || !bulletsList) return;
    var hotspots = panel.querySelectorAll('.sv-hotspot');
    var html = '';
    hotspots.forEach(function(hs) {
      var title = hs.dataset.title || hs.getAttribute('data-title');
      if (title) {
        html += '<li>' + title + '</li>';
      }
    });
    bulletsList.innerHTML = html;
  }

  /* ── Hotspot tooltip (desktop hover) ── */
  document.querySelectorAll('.sv-hotspot').forEach(function(dot) {
    dot.addEventListener('mouseenter', function() {
      var tooltip = this.querySelector('.sv-hotspot__tooltip');
      if (tooltip) tooltip.style.display = 'block';
    });
    dot.addEventListener('mouseleave', function() {
      var tooltip = this.querySelector('.sv-hotspot__tooltip');
      if (tooltip) tooltip.style.display = 'none';
    });
    // Mobile: tap to open bottom sheet
    dot.addEventListener('click', function(e) {
      if (window.innerWidth > 768) return;
      e.preventDefault();
      var title = this.dataset.title || '';
      var desc = this.dataset.desc || '';
      var img = this.dataset.img || '';
      var mobileSheet = document.getElementById('hotspotMobile');
      if (mobileSheet) {
        var mImg = document.getElementById('hsMobileImg');
        var mTitle = document.getElementById('hsMobileTitle');
        var mDesc = document.getElementById('hsMobileDesc');
        if (mImg) { mImg.src = img; mImg.style.display = img ? 'block' : 'none'; }
        if (mTitle) mTitle.textContent = title;
        if (mDesc) mDesc.textContent = desc;
        mobileSheet.classList.add('is-open');
      }
    });
  });

  /* ── Mobile hotspot close ── */
  var hsMobileClose = document.getElementById('hsMobileClose');
  if (hsMobileClose) {
    hsMobileClose.addEventListener('click', function() {
      document.getElementById('hotspotMobile').classList.remove('is-open');
    });
  }

  /* ── Spec accordion (details/summary already work natively) ── */

  /* ── Sticky mobile ATC bar ── */
  var stickyATC = document.getElementById('stickyATC');
  var pdpAtcBtn = document.getElementById('pdpAtcBtn');
  if (stickyATC && pdpAtcBtn) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyATC.classList.remove('is-visible');
        } else {
          stickyATC.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(pdpAtcBtn);
  }

  

  /* ── PDP Gallery Swipe + Arrow Navigation ── */
  (function() {
    var mainWrap = document.getElementById('galleryMainWrap') || document.querySelector('.sv-pdp-gallery__main');
    var mainImg = document.getElementById('galleryMain');
    var thumbs = document.querySelectorAll('.sv-pdp-thumb');
    if (!mainImg || thumbs.length < 2) return;

    var currentIndex = 0;
    var images = [];
    thumbs.forEach(function(t) {
      var src = t.dataset.src;
      if (src) images.push(src);
    });
    if (images.length === 0) return;

    function goTo(idx) {
      if (idx < 0) idx = images.length - 1;
      if (idx >= images.length) idx = 0;
      currentIndex = idx;
      
      // Remove existing video if any
      var existingVideo = mainWrap ? mainWrap.querySelector('video') : null;
      if (existingVideo) { existingVideo.pause(); existingVideo.remove(); }
      mainImg.style.display = '';
      mainImg.src = images[currentIndex];
      
      thumbs.forEach(function(t, i) {
        t.classList.toggle('is-active', i === currentIndex);
        t.style.borderColor = (i === currentIndex) ? 'var(--sv-green)' : 'transparent';
      });
      // Preload adjacent images
      [currentIndex - 1, currentIndex + 1, currentIndex + 2].forEach(function(pi) {
        var ni = pi < 0 ? images.length - 1 : (pi >= images.length ? 0 : pi);
        if (images[ni]) { var img = new Image(); img.src = images[ni]; }
      });
    }

    // Preload first few images on page load
    images.slice(0, 3).forEach(function(src) { var img = new Image(); img.src = src; });

    // Arrow buttons
    if (mainWrap) {
      var wrap = mainWrap.parentElement || mainWrap;
      wrap.style.position = 'relative';

      var arrowStyle = 'position:absolute;top:50%;transform:translateY(-50%);z-index:5;width:40px;height:40px;background:rgba(0,0,0,.5);border:none;border-radius:50%;color:#fff;font-size:1.2rem;cursor:pointer;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .2s;';
      
      var prevBtn = document.createElement('button');
      prevBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
      prevBtn.setAttribute('style', arrowStyle + 'left:12px;');
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.onclick = function(e) { e.preventDefault(); goTo(currentIndex - 1); };

      var nextBtn = document.createElement('button');
      nextBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
      nextBtn.setAttribute('style', arrowStyle + 'right:12px;');
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.onclick = function(e) { e.preventDefault(); goTo(currentIndex + 1); };

      wrap.appendChild(prevBtn);
      wrap.appendChild(nextBtn);

      // Show arrows on hover (desktop) or always on mobile
      wrap.addEventListener('mouseenter', function() { prevBtn.style.opacity = '1'; nextBtn.style.opacity = '1'; });
      wrap.addEventListener('mouseleave', function() { prevBtn.style.opacity = '0'; nextBtn.style.opacity = '0'; });
      if (window.innerWidth <= 768) { prevBtn.style.opacity = '.6'; nextBtn.style.opacity = '.6'; }
    }

    // Touch swipe
    var startX = 0, startY = 0, tracking = false;
    var target = mainWrap || mainImg;

    target.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    target.addEventListener('touchmove', function(e) {
      if (!tracking) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      // Only horizontal swipe
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 30) {
        e.preventDefault();
      }
    }, { passive: false });

    target.addEventListener('touchend', function(e) {
      if (!tracking) return;
      tracking = false;
      var endX = e.changedTouches[0].clientX;
      var dx = endX - startX;
      if (Math.abs(dx) > 50) {
        if (dx < 0) goTo(currentIndex + 1); // swipe left = next
        else goTo(currentIndex - 1); // swipe right = prev
      }
    });

    // Keyboard
    document.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') goTo(currentIndex - 1);
      if (e.key === 'ArrowRight') goTo(currentIndex + 1);
    });
  })();

  /* Cookie banner runs after init to not block page setup */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieConsent);
  } else {
    initCookieConsent();
  }


  /* ── Accordion (replaces stripped details/summary) ── */
  document.querySelectorAll('.sv-accordion__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var content = this.nextElementSibling;
      var isOpen = this.classList.contains('is-open');
      // Close all in same group
      var parent = this.closest('.sv-specs') || this.closest('.sv-accordion-group') || this.parentElement;
      if (parent) {
        parent.querySelectorAll('.sv-accordion__trigger').forEach(function(t) {
          t.classList.remove('is-open');
          if (t.nextElementSibling) t.nextElementSibling.style.display = 'none';
        });
      }
      if (!isOpen && content) {
        this.classList.add('is-open');
        content.style.display = 'block';
      }
    });
  });
})();
